import { Component } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from '@core/auth.service';
import { ModalController } from "@ionic/angular";
import { JackpotTriggersService } from 'src/app/services/jackpot-triggers.service';
import { SyndicateDataService } from "src/app/services/syndicate-data.service";

@Component({
  selector: 'app-selected-gold-ring-lost',
  standalone: true,
  imports: [],
  templateUrl: './selected-gold-ring-lost.component.html',
  styleUrl: './selected-gold-ring-lost.component.scss'
})
export class SelectedGoldRingLostComponent {
  languageCode: string = "en";
  lostPopupTranslatedData: any;
  yesButton: string;
  noButton: string;
  description: string;
  title: string;
  constructor(
    private matDialog: MatDialog,
    private router: Router,
    private modalCtrl: ModalController,
    public syndicateDataService: SyndicateDataService,
    private jackpotTriggerService: JackpotTriggersService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe(
        (data) => {
          this.lostPopupTranslatedData = data?.["gold_rings_lost_popup"];
          this.yesButton = this.lostPopupTranslatedData?.yes_button;
          this.noButton = this.lostPopupTranslatedData?.no_button;
          this.description = this.lostPopupTranslatedData?.description;
          this.title = this.lostPopupTranslatedData?.title;
        },
        (err) => {
          return err;
        }
      );
    });
  }

  goToSyndicates() {
    this.matDialog.closeAll();
    this.modalCtrl.dismiss(true).catch((err) => {
      return err;
    });
    this.router.navigateByUrl("mainTabs/tabs/syndicate");
  }

  goBack() {
    this.modalCtrl.dismiss(true).catch((err) => {
      return err;
    });
  }

  async closePopup() {
    this.matDialog.closeAll();
  }
}
